"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantProfileUpdateSchema = exports.MerchantProfileUpdateWithoutRefineSchema = exports.MerchantProfileUpdateScalarSchema = exports.MerchantProfileCreateSchema = exports.MerchantProfileCreateWithoutRefineSchema = exports.MerchantProfileCreateScalarSchema = exports.MerchantProfilePrismaUpdateSchema = exports.MerchantProfilePrismaCreateSchema = exports.MerchantProfileSchema = exports.MerchantProfileWithoutRefineSchema = exports.MerchantProfileScalarSchema = exports.refineMerchantProfile = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const MerchantType_schema_1 = require("../enums/MerchantType.schema");
const VendorType_schema_1 = require("../enums/VendorType.schema");
const MerchantProfileAddressState_schema_1 = require("../enums/MerchantProfileAddressState.schema");
const common_1 = require("../common");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    merchantType: MerchantType_schema_1.MerchantTypeSchema,
    vendorType: VendorType_schema_1.VendorTypeSchema,
    name: zod_1.z.string(),
    descriptionEN: zod_1.z.string().nullish(),
    descriptionFR: zod_1.z.string().nullish(),
    street: zod_1.z.string().trim().min(3).max(50),
    city: zod_1.z.string().trim().min(3).max(50),
    state: MerchantProfileAddressState_schema_1.MerchantProfileAddressStateSchema,
    zip: zod_1.z.string().trim(),
    phone: zod_1.z.string().trim().min(10).max(20),
    website: zod_1.z.string().trim().regex(new RegExp("^((https?)://)?(www.)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$")).nullish(),
    embeddedMap: zod_1.z.string().trim().max(1000).nullish(),
    merchantAreaEN: zod_1.z.string().default(""),
    merchantAreaFR: zod_1.z.string().default(""),
    merchantTypeEN: zod_1.z.string().default(""),
    merchantTypeFR: zod_1.z.string().default(""),
    latitude: common_1.DecimalSchema.default(0),
    longitude: common_1.DecimalSchema.default(0),
    activated: zod_1.z.boolean().default(false),
    defaultDiscount: zod_1.z.number().gte(20).lte(100).default(20),
    applicationFeePercentage: zod_1.z.number().gte(0).lte(100).default(5),
    weeklyCouponLimit: zod_1.z.number().gte(0).default(0),
    displayOrder: zod_1.z.number().gte(0).default(9999),
    banners: zod_1.z.array(zod_1.z.string()),
    stripeAccountId: zod_1.z.string().nullish(),
    stripeOnboarded: zod_1.z.boolean().default(false),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
}).strict();
const relationSchema = zod_1.z.object({
    daysOff: zod_1.z.array(zod_1.z.unknown()).optional(),
    ratings: zod_1.z.array(zod_1.z.unknown()).optional(),
    coupons: zod_1.z.array(zod_1.z.unknown()).optional(),
    dishAddOnCategories: zod_1.z.array(zod_1.z.unknown()).optional(),
    merchantCouponRedeemer: zod_1.z.record(zod_1.z.unknown()).optional(),
    user: zod_1.z.record(zod_1.z.unknown()),
    merchantOpeningHours: zod_1.z.array(zod_1.z.unknown()).optional(),
    capacity: zod_1.z.record(zod_1.z.unknown()).optional(),
    merchantTags: zod_1.z.array(zod_1.z.unknown()).optional(),
    dishCategories: zod_1.z.array(zod_1.z.unknown()).optional(),
    orders: zod_1.z.array(zod_1.z.unknown()).optional(),
});
const fkSchema = zod_1.z.object({
    userId: zod_1.z.string().uuid().optional(),
});
/**
* Schema refinement function for applying `@@validate` rules.
*/
function refineMerchantProfile(schema) {
    return schema.refine((value) => (((value === null || value === void 0 ? void 0 : value.activated) !== undefined ? ((!(value === null || value === void 0 ? void 0 : value.activated))) : true) || (((((((value === null || value === void 0 ? void 0 : value.name) !== null && (value === null || value === void 0 ? void 0 : value.name) !== undefined) && ((value === null || value === void 0 ? void 0 : value.street) !== null && (value === null || value === void 0 ? void 0 : value.street) !== undefined)) && ((value === null || value === void 0 ? void 0 : value.city) !== null && (value === null || value === void 0 ? void 0 : value.city) !== undefined)) && ((value === null || value === void 0 ? void 0 : value.state) !== null && (value === null || value === void 0 ? void 0 : value.state) !== undefined)) && ((value === null || value === void 0 ? void 0 : value.zip) !== null && (value === null || value === void 0 ? void 0 : value.zip) !== undefined)) && ((value === null || value === void 0 ? void 0 : value.phone) !== null && (value === null || value === void 0 ? void 0 : value.phone) !== undefined))), { message: "Merchant profile should be completed before activation.", });
}
exports.refineMerchantProfile = refineMerchantProfile;
/**
 * `MerchantProfile` schema excluding foreign keys and relations.
 */
exports.MerchantProfileScalarSchema = baseSchema;
/**
 * `MerchantProfile` schema prior to calling `.refine()` for extensibility.
 */
exports.MerchantProfileWithoutRefineSchema = exports.MerchantProfileScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * `MerchantProfile` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.MerchantProfileSchema = refineMerchantProfile(exports.MerchantProfileWithoutRefineSchema);
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.MerchantProfilePrismaCreateSchema = refineMerchantProfile(baseSchema.partial().passthrough());
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.MerchantProfilePrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    merchantType: MerchantType_schema_1.MerchantTypeSchema,
    vendorType: VendorType_schema_1.VendorTypeSchema,
    name: zod_1.z.string(),
    descriptionEN: zod_1.z.string().nullish(),
    descriptionFR: zod_1.z.string().nullish(),
    street: zod_1.z.string().trim().min(3).max(50),
    city: zod_1.z.string().trim().min(3).max(50),
    state: MerchantProfileAddressState_schema_1.MerchantProfileAddressStateSchema,
    zip: zod_1.z.string().trim(),
    phone: zod_1.z.string().trim().min(10).max(20),
    website: zod_1.z.string().trim().regex(new RegExp("^((https?)://)?(www.)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$")).nullish(),
    embeddedMap: zod_1.z.string().trim().max(1000).nullish(),
    merchantAreaEN: zod_1.z.string().default(""),
    merchantAreaFR: zod_1.z.string().default(""),
    merchantTypeEN: zod_1.z.string().default(""),
    merchantTypeFR: zod_1.z.string().default(""),
    latitude: common_1.DecimalSchema.default(0),
    longitude: common_1.DecimalSchema.default(0),
    activated: zod_1.z.boolean().default(false),
    defaultDiscount: zod_1.z.union([zod_1.z.number().gte(20).lte(100).default(20), zod_1.z.record(zod_1.z.unknown())]),
    applicationFeePercentage: zod_1.z.union([zod_1.z.number().gte(0).lte(100).default(5), zod_1.z.record(zod_1.z.unknown())]),
    weeklyCouponLimit: zod_1.z.union([zod_1.z.number().gte(0).default(0), zod_1.z.record(zod_1.z.unknown())]),
    displayOrder: zod_1.z.union([zod_1.z.number().gte(0).default(9999), zod_1.z.record(zod_1.z.unknown())]),
    banners: zod_1.z.array(zod_1.z.string()),
    stripeAccountId: zod_1.z.string().nullish(),
    stripeOnboarded: zod_1.z.boolean().default(false),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date())
}).partial().passthrough();
/**
 * `MerchantProfile` schema for create operations excluding foreign keys and relations.
 */
exports.MerchantProfileCreateScalarSchema = baseSchema.partial({
    merchantType: true, vendorType: true, merchantAreaEN: true, merchantAreaFR: true, merchantTypeEN: true, merchantTypeFR: true, latitude: true, longitude: true, activated: true, defaultDiscount: true, applicationFeePercentage: true, weeklyCouponLimit: true, displayOrder: true, banners: true, stripeOnboarded: true, createdAt: true, updatedAt: true
});
/**
 * `MerchantProfile` schema for create operations prior to calling `.refine()` for extensibility.
 */
exports.MerchantProfileCreateWithoutRefineSchema = exports.MerchantProfileCreateScalarSchema.merge(fkSchema);
/**
 * `MerchantProfile` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.MerchantProfileCreateSchema = refineMerchantProfile(exports.MerchantProfileCreateWithoutRefineSchema);
/**
 * `MerchantProfile` schema for update operations excluding foreign keys and relations.
 */
exports.MerchantProfileUpdateScalarSchema = baseSchema.partial();
/**
 * `MerchantProfile` schema for update operations prior to calling `.refine()` for extensibility.
 */
exports.MerchantProfileUpdateWithoutRefineSchema = exports.MerchantProfileUpdateScalarSchema.merge(fkSchema.partial());
/**
 * `MerchantProfile` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.MerchantProfileUpdateSchema = refineMerchantProfile(exports.MerchantProfileUpdateWithoutRefineSchema);
